import React from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import styled from "styled-components";
import { Categories, categoriesState, ToDo, toDoState } from "../../atoms";

const ToDoItemWrapper = styled.li`
  background-color: #ffc9c4;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin:1em;
  padding:1em;
  width: 75%;
  border-radius: 2rem;
  div{
      display: flex;
      flex-direction: column;
  }
`

const ToDoText = styled.span`
  color: #797979;
  font-weight: bold; 
`

const Button = styled.button`
  border-radius: 10px;
  border: none;
  padding:0.7rem;
  margin:0.7rem;
  background-color: #ffa8bea9;
  &.delete{
    color:#52039c;
    background-color: #d5a8ff;
  }
`
const DeleteArea = styled.div`
align-items: center;
`

const ListWithCategories = ({ text, category: currentCategory, id }: ToDo) => {
  const setToDos = useSetRecoilState(toDoState);
  const categories = useRecoilValue(categoriesState)
  const onClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    const {
      currentTarget: { name },
    } = event;
    setToDos((oldToDos) => {
      const targetIndex = oldToDos.findIndex((toDo) => toDo.id === id);
      const newToDo = { text, id, category: name as any };
      return [
        ...oldToDos.slice(0, targetIndex),
        newToDo,
        ...oldToDos.slice(targetIndex + 1),
      ];
    });
  };
  const handleDelete = () => {
    setToDos((oldToDos) => {
      const targetIndex = oldToDos.findIndex((toDo) => toDo.id === id);
      return [
        ...oldToDos.slice(0, targetIndex),
        ...oldToDos.slice(targetIndex + 1),
      ];
    });
  }
  return (
    <ToDoItemWrapper>
      <div>
        {currentCategory !== Categories.DOING && (
          <Button name={Categories.DOING} onClick={onClick}>
            ✔️ 하는 중
          </Button>
        )}
        {currentCategory !== Categories.TO_DO && (
          <Button name={Categories.TO_DO} onClick={onClick}>
            ✔️ 할 일
          </Button>
        )}
        {currentCategory !== Categories.DONE && (
          <Button name={Categories.DONE} onClick={onClick}>
            ✔️ 완료
          </Button>
        )}
        {
          categories.map((category) => {
            if (category !== currentCategory) {
              return <Button key={category} name={category} onClick={onClick}>
                ✔️ {category}
              </Button>
            }
          })
        }
      </div>
      <DeleteArea>
        <ToDoText>{text}</ToDoText>
        <Button className="delete" onClick={handleDelete}>❌ 삭제하기</Button>
      </DeleteArea>

    </ToDoItemWrapper>
  )
}
export default ListWithCategories